/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     ItemTypes
//   Details:    Item Types store
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 102715 16/08/19 JC  M01  Added Contacts
// 103782 10/12/19 JC  M02  Added MyTraining
// 111318 25/01/21 JC  M03  Handle no 'type' for contacts
//-------------------------------------------------------
*/

import { fetchActions } from "../FetchWrapper";
import { itemCategories } from "../constants/ItemCategories";
import { userActions } from './Authentication';

const requestType = '_ITEM_TYPES_REQUEST';
const successType = '_ITEM_TYPES_SUCCESS';
const failureType = '_ITEM_TYPES_FAILURE';

const initialState = {
	isLoading: false,
	items: []
};

export const itemTypeActions = {
	get
};

function get(itemCategory) {
	return (dispatch, getState) => {
		if (!getState().clientConfiguration.config.endpoint)
			return;

		dispatch(_request(itemCategory));
		var requestShape = getRequestShapeForType(getState().clientConfiguration.config.endpoint, itemCategory);

		if (requestShape.error) {
			dispatch(_failure(itemCategory, requestShape.error));
    } else if (requestShape.url && requestShape.url !== undefined) { //M03 check that requestShape has a url

			const ticket = getState().authentication.user.ticket;
			const hasDataFieldName = requestShape.hasDataFieldName;

			fetchActions.get(requestShape.url, ticket)
				.then(
					response => {
						var itemTypes = response.data.map((item, i) => {
							// Map specific new/history data property to a standard data property
							if (item.hasOwnProperty(hasDataFieldName)) {
								item["hasData"] = item[hasDataFieldName];
								delete item[hasDataFieldName];
							}
							return item;
						});

						dispatch(_success(itemCategory, itemTypes ));
					},
					error => {
						if (error.sessionExpired) {
							dispatch(userActions.sessionExpired());
						}
						else {
							var message = `Could not get ${requestShape.name}: ${error.message}`;
							dispatch(_failure(itemCategory, message));
						}
					}
				);
		}
	};

	// Gets information on how the request should appear for the recognised types
	function getRequestShapeForType(baseUrl, itemCategory) {
		switch (itemCategory) {
			case itemCategories.unreadNotices:
				return {
					name: "unread notices",
					url: baseUrl + "/employeenoticetypes",
					hasDataFieldName: "hasNewData"
				};

			case itemCategories.readNotices:
				return {
					name: "read notices",
					url: baseUrl + "/employeenoticetypes",
					hasDataFieldName: "hasHistoryData"
				};

			case itemCategories.unreadDocuments:
				return {
					name: "unread documents",
					url: baseUrl + "/employeedocumenttypes",
					hasDataFieldName: "hasNewData"
				};

			case itemCategories.readDocuments:
				return {
					name: "read documents",
					url: baseUrl + "/employeedocumenttypes",
					hasDataFieldName: "hasHistoryData"
				};

			case itemCategories.unreadPay:
				return {
					name: "unread pay",
					url: baseUrl + "/employeepayrecordtypes",
					hasDataFieldName: "hasNewData"
				};

			case itemCategories.readPay:
				return {
					name: "read pay",
					url: baseUrl + "/employeepayrecordtypes",
					hasDataFieldName: "hasHistoryData"
				};

			case itemCategories.unreadRequests:
				return {
					name: "unread requests",
					url: baseUrl + "/employeerequesttypes",
					hasDataFieldName: "hasNewData"
				};

			case itemCategories.readRequests:
				return {
					name: "read requests",
					url: baseUrl + "/employeerequesttypes",
					hasDataFieldName: "hasHistoryData"
                };

            //M01 all Contacts
            case itemCategories.allContacts:
                return {
                    //return nothing as no specific item types
                };

            case itemCategories.uncompletedTraining: //M02
                return {
                    name: "uncompleted training",
                    url: baseUrl + "/employeetrainingtypes",
                    hasDataFieldName: "hasNewData"
                };

            case itemCategories.completedTraining: //M02
                return {
                    name: "completed training",
                    url: baseUrl + "/employeetrainingtypes",
                    hasDataFieldName: "hasHistoryData"
                };

			default:
				return {
					error: "Unrecognised item type in ItemTypes.js:getRequestShapeForType: '" + itemCategory + "'."
				};
		}
	}

	function _request(itemCategory) { return { type: itemCategory + requestType }; }
	function _success(itemCategory, items) { return { type: itemCategory + successType, items }; }
	function _failure(itemCategory, error) { return { type: itemCategory + failureType, error }; }
}

export const createNamedReducer = (itemCategory = '') => {
	return (state, action) => {
		state = state || initialState;

		switch (action.type) {
			case itemCategory + requestType:
				return { ...state, isLoading: true };

			case itemCategory + successType:
				return { ...state, isLoading: true, items: action.items, error: {} };

			case itemCategory + failureType:
				return { ...state, isLoading: true, error: action.error };

			default:
				return state;
		}
	};
};